"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _ThumbnailBroken = require("../icons/ThumbnailBroken");
var _Link = require("./Link");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
var _IconButton = require("./IconButton");
var _lodash = _interopRequireDefault(require("lodash"));
var _moment = _interopRequireDefault(require("moment"));
var _clsx3 = _interopRequireDefault(require("clsx"));
var _FileType = _interopRequireDefault(require("./FileType"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyle = (0, _core.makeStyles)(function (theme) {
  return (0, _core.createStyles)({
    root: _objectSpread(_objectSpread({}, theme.direction === "rtl" ? {
      padding: "1px 1px 1px 4px"
    } : {
      padding: "1px 4px 1px 1px"
    }), {}, {
      backgroundColor: _pittaModules.LightColors.primary["7"],
      borderRadius: 4,
      // justifyContent: "space-between",
      display: "flex",
      width: "fit-content"
    }),
    aiBg: {
      backgroundColor: _pittaModules.LightColors.secondary["11"]
    },
    textWrap: _objectSpread({
      minWidth: 277,
      display: "flex",
      flexDirection: "column",
      flex: 1,
      padding: theme.spacing(0.5, 2),
      backgroundColor: _pittaModules.LightColors.primary["1"]
    }, theme.direction === "rtl" ? {
      paddingLeft: 0
    } : {
      paddingRight: 0
    }),
    view: _objectSpread({
      width: 99,
      height: 99,
      fill: "none"
    }, theme.direction === "rtl" ? {
      borderRadius: "0 4px 4px 0"
    } : {
      borderRadius: "4px 0 0 4px"
    }),
    btnBg: _objectSpread({
      backgroundColor: _pittaModules.LightColors.primary["1"]
    }, theme.direction === "rtl" ? {
      borderRadius: "4px 0 0 4px"
    } : {
      borderRadius: "0 4px 4px 0"
    }),
    button: {
      display: "flex"
    },
    close: {
      padding: theme.spacing(0.5),
      "&:hover": {
        color: _pittaModules.LightColors.primary["8"]
      }
    },
    imgDiv: _objectSpread({
      display: "flex",
      minWidth: 99,
      minHeight: 99,
      backgroundColor: _pittaModules.LightColors.primary["1"],
      position: "relative"
    }, theme.direction === "rtl" ? {
      borderRadius: "0 4px 4px 0"
    } : {
      borderRadius: "4px 0 0 4px"
    }),
    eventTypeDiv: {
      position: "absolute",
      top: 8,
      right: 8
    },
    /* mantis - 8755, message 긴 경우 생략표시 (Leehj) */
    msgStyle: {
      paddingBottom: 4
    },
    ellipsis: {
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis"
    },
    liveViewBtn: {
      position: "relative"
    },
    liveViewRedDot: {
      position: "absolute",
      right: -8,
      top: 0,
      animation: "$fade 3000ms infinite"
    },
    "@keyframes fade": {
      from: {
        opacity: 1.0
      },
      "50%": {
        opacity: 0.1
      },
      to: {
        opacity: 1.0
      }
    }
  });
});
var Notification = function Notification(props) {
  var _t, _t2;
  var event = props.event,
    disablePlayback = props.disablePlayback,
    disableLiveview = props.disableLiveview,
    t = props.t,
    onClose = props.onClose,
    onLiveView = props.onLiveView,
    onPlayback = props.onPlayback;
  var classes = useStyle(props);
  var theme = (0, _core.useTheme)();
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgError = _useState2[0],
    setImgError = _useState2[1];
  var isAI = (0, _react.useMemo)(function () {
    return _lodash.default.includes(_pittaModules.DMS_EVENTS, event.msg_code);
  }, [event.msg_code]);

  // mantis - 8784, "ALARM_DETECTED"도 playback버튼 안보이게 수정(Leehj).
  var hidePlayback = (0, _react.useMemo)(function () {
    return _lodash.default.includes(_pittaModules.NO_PLAYBACK_EVENTS, event.msg_code);
  }, [event.msg_code]);

  // mantis - 8775, "ALARM_MASK_OFF", "ALARM_DROWSY_SECOND" liveview 색 변경을 위함.
  var liveViewRed = (0, _react.useMemo)(function () {
    return _lodash.default.includes(["ALARM_MASK_OFF", "ALARM_DROWSY_SECOND"], event.msg_code);
  }, [event.msg_code]);
  var noLiveView = (0, _react.useMemo)(function () {
    return _lodash.default.includes(_pittaModules.NO_LIVEVIEW_EVENTS, event.msg_code);
  }, [event.msg_code]);
  var thumbnailMarkup = (0, _react.useMemo)(function () {
    if (_lodash.default.includes(_pittaModules.NO_THUMBNAIL_EVENTS, event.msg_code)) {
      return;
    } else {
      var fileType = "Event";
      if (event.msg_code === "ALARM_MANUAL") {
        fileType = "Manual";
      } else if (_lodash.default.includes(_pittaModules.PARKING_EVENTS, event.msg_code)) {
        fileType = "Parking";
      }
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes.imgDiv
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: classes.eventTypeDiv
      }, /*#__PURE__*/_react.default.createElement(_FileType.default, {
        fileType: fileType,
        isAI: isAI
      })), imgError || !event.image_url ? /*#__PURE__*/_react.default.createElement(_ThumbnailBroken.ThumbnailBroken, {
        className: classes.view
      }) : /*#__PURE__*/_react.default.createElement("img", {
        alt: "thumbnail",
        className: classes.view,
        src: event.image_url,
        onError: function onError() {
          return setImgError(true);
        }
      }));
    }
  }, [classes.eventTypeDiv, classes.imgDiv, classes.view, event.image_url, event.msg_code, imgError, isAI]);
  var _useMemo = (0, _react.useMemo)(function () {
      var sIndex = event.alert.indexOf("[");
      var eIndex = event.alert.indexOf("]") + 1;
      if (sIndex > -1 && eIndex > -1) {
        return [event.alert.slice(sIndex, eIndex), event.alert.slice(eIndex)];
      } else {
        return [undefined, undefined];
      }
    }, [event.alert]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    devName = _useMemo2[0],
    message = _useMemo2[1];
  var vdate = (0, _react.useMemo)(function () {
    var _event$date;
    //10160 이슈 수정
    if (event.event_filename && event.event_filename.indexOf(".mp4") > -1) {
      var dateStrings = event.event_filename.split("_");
      var time = (0, _moment.default)("".concat(dateStrings[0], " ").concat(dateStrings[1]), "YYYYMMDD HHmmss");
      if (time.isValid()) {
        return time;
      }
    } else if (event.event_time) {
      var dateStrings2 = event.event_time.split("_");
      var time2 = (0, _moment.default)("".concat(dateStrings2[0], " ").concat(dateStrings2[1]), "YYYYMMDD HHmmss");
      if (time2.isValid()) {
        return time2;
      }
    }
    return (_event$date = event.date) !== null && _event$date !== void 0 ? _event$date : (0, _moment.default)();
  }, [event.date, event.event_filename, event.event_time]);

  // console.log(event.alert, devName, message);

  var liveViewMarkup = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react.default.createElement("svg", {
      width: "6",
      height: "6",
      viewBox: "0 0 6 6",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: classes.liveViewRedDot
    }, /*#__PURE__*/_react.default.createElement("circle", {
      cx: "3",
      cy: "3",
      r: "3",
      fill: "#F95D67"
    }));
  }, [classes.liveViewRedDot]);
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    dir: theme.direction,
    elevation: 0,
    className: (0, _clsx3.default)(classes.root, _defineProperty({}, classes.aiBg, isAI))
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: {
      display: "flex",
      width: 376
    }
  }, thumbnailMarkup, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.textWrap
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Caption",
    htmlColor: _pittaModules.LightColors.primary["3"],
    style: {
      paddingBottom: 4
    }
  }, vdate === null || vdate === void 0 ? void 0 : vdate.format("MMM DD, h:m:ss A")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "SmallBold",
    htmlColor: _pittaModules.LightColors.primary["0"]
  }, devName === null || devName === void 0 ? void 0 : devName.replaceAll("[", "").replaceAll("]", "")), /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "Small",
    htmlColor: _pittaModules.LightColors.primary["0"],
    className: (0, _clsx3.default)(classes.msgStyle, _defineProperty({}, classes.ellipsis, thumbnailMarkup))
  }, message), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.button
  }, !noLiveView && /*#__PURE__*/_react.default.createElement("div", {
    className: classes.liveViewBtn
  }, liveViewRed && liveViewMarkup, /*#__PURE__*/_react.default.createElement(_Link.Link, {
    category: "Default",
    variant: "Caption"
    // mantis - 8775, "ALARM_MASK_OFF", "ALARM_DROWSY_SECOND" liveview 색 빨간색으로 변경
    // color={liveViewRed ? "dangerous" : "primary"}
    ,
    color: "primary",
    onClick: function onClick() {
      return onLiveView(event);
    },
    disable: disableLiveview,
    mode: "anchor"
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "SmallBold"
  }, (_t = t === null || t === void 0 ? void 0 : t("Live view")) !== null && _t !== void 0 ? _t : "Live view"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      padding: "0 24px"
    }
  }, !hidePlayback && /*#__PURE__*/_react.default.createElement(_Link.Link, {
    category: "Default",
    variant: "Caption",
    color: "primary",
    onClick: function onClick() {
      return onPlayback(event);
    },
    disable: disablePlayback,
    mode: "anchor"
  }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
    category: "Default",
    variant: "SmallBold"
  }, (_t2 = t === null || t === void 0 ? void 0 : t("Playback")) !== null && _t2 !== void 0 ? _t2 : "Playback")))))), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.btnBg
  }, /*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    className: classes.close,
    color: "secondary",
    onClick: onClose
  }, /*#__PURE__*/_react.default.createElement(_Close.default, {
    fontSize: "small"
  }))));
};
exports.Notification = Notification;